import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { Container as Grid } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import CustomProgressBar from '../CustomProgressBar'

import Question from '../../../client/components/Flowciraptor'
import QuestionHint from '../../../client/components/QuestionHint'
import SuccessModal from '../../../client/components/SuccessModal'
import IncorrectModal from '../../../client/components/IncorrectModal'
import ShowAnswerModal from '../../../client/components/ShowAnswerModal'
import ActivityFooter from '../../../client/components/ActivityFooter'
import SlowDownModal from '../../../client/components/SlowDownModal'
import SlowDeductModal from '../../../client/components/SlowDeductModal'
import ChallengeQuestionModal, { CHALLENGE_EMAIL_STEP } from '../../../client/components/ChallengeQuestionModal'
import ChallengeSentModal from '../../../client/components/ChallengeSentModal'
import MidActivityModal from '../../../client/components/MidActivityModal'
import CompletedActivityModal from '../../../client/components/CompletedActivityModal'
import LCRPCompletedActivityModal from '../../../client/components/LCRP-CompletedActivityModal'
import TopBar from '../../../client/components/TopBar'
import Clickable from '../../../client/components/Clickable'
import FooterBar, { CenterRoundButton } from '../../../client/components/FooterBar'
import QuestionValueToolTip from '../../../client/components/ToolTips/QuestionValue'
import ScoreValueToolTip from '../../../client/components/ToolTips/ScoreValue'
import EbookModal from '../../../client/components/EbookModal'
import ArgaErrorBar from '../../../client/containers/ArgaErrorBar/argaErrorBar.js'
import CoachSignupModal from '../../../client/components/CoachSignupModal/coachSignupModal.js'
import LCSplitPane, { isVitalSourceURL } from '../../../client/components/LCSplitPane'
import EbookSplitMobile from '../../../client/components/EbookSplitMobile'

import baseStyle from 'Styles/base.css'
import progressBarStyle from 'Styles/progress-bar.css'
import buttonStyle from 'Styles/button.css'
import style from './style.css'

import arrowLeftIcon from 'Assets/arrow-left.svg'

import params from '../../../client/lib/params'
const { headerStyle } = params()

function parseEbookUrl (string) {
  const idxStart = string.indexOf('[[')
  const idxEnd = string.indexOf(']]')
  if (idxStart === -1 || idxEnd === -1) return ''
  return string.slice(idxStart + 2, idxEnd)
}

export default class Activity extends Component {
  constructor (props) {
    super(props)
    this.onDisplayAnswer = this.onDisplayAnswer.bind(this)
    this.onSubmitAnswer = this.onSubmitAnswer.bind(this)
    this.onShowScoreValueInfo = this.onShowScoreValueInfo.bind(this)
    this.onShowQuestionValueInfo = this.onShowQuestionValueInfo.bind(this)
    this.onNextItem = this.onNextItem.bind(this)
    this.onPauseActivity = this.onPauseActivity.bind(this)
    this.state = {
      isAnswerSelected: false,
      answerSelected: null,
      challengeError: false,
      splitPane: false,
      splitLeftFooterWidth: '50%',
      activityHasBeenCompleted: false
    }
  }

  componentDidMount () {
    if (global && global.MathJax) {
      return global.MathJax.Hub.Queue(['Typeset', global.MathJax.Hub])
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.activityTitle) {
      document.title = `Quiz for ${nextProps.activityTitle}`
    }

    // user just started a new question
    if (this.props.score.curCard.completed) {
      // reset state for the next question
      this.setState({
        isAnswerSelected: false,
        answerSelected: null
      })
    }
  }

  componentDidUpdate (prevProps) {
    if (((prevProps.score.curCard.completed !== this.props.score.curCard.completed &&
      prevProps.uiState.isCompletedActivityModalDisplayed !== this.props.uiState.isCompletedActivityModalDisplayed &&
      this.props.score.curCard.completed &&
      this.props.uiState.isCompletedActivityModalDisplayed) ||
      (this.props.score.activityScore >= this.props.score.scoreTarget)) &&
      !this.state.activityHasBeenCompleted) {
      this.setState({
        activityHasBeenCompleted: true
      })
    }
    if (global && global.MathJax) {
      return global.MathJax.Hub.Queue(['Typeset', global.MathJax.Hub])
    }
  }

  onAnswer (answerValue) {
    if (_.isEmpty(answerValue)) {
      this.setState({
        isAnswerSelected: false
      })
    } else {
      this.setState({
        isAnswerSelected: true,
        answerSelected: answerValue
      })
    }
  }

  async onSubmitAnswer (answerValue) {

    // Ftech latest network status before submitting the answer
    await this.props.actions.updateNetworkStatus();
    if (!this.props.uiState.isNetworkUp) {
      this.props.actions.showNetworkIssueModal();
      return;
    }

    window.scrollTo(0, 0)
    const fqUid = this.props.score.curCard.meta.fq_uid
    this.props.actions.saveAttempt(answerValue, fqUid, this.props.score.curCard.questionType)
    this.setState({
      isAnswerSelected: false
    })
  }

  async onDisplayAnswer () {
    // Ftech latest network status before showing the answer
    await this.props.actions.updateNetworkStatus();
    if (!this.props.uiState.isNetworkUp) {
      this.props.actions.showNetworkIssueModal();
      return;
    }
    const fqUid = this.props.score.curCard.meta.fq_uid
    this.props.actions.showAnswer(this.state.answerSelected, fqUid)
    this.setState({
      isAnswerSelected: false
    })
  }

  async onShowHint () {
    // Ftech latest network status before providing a hint
    await this.props.actions.updateNetworkStatus();
    if (!this.props.uiState.isNetworkUp) {
      this.props.actions.showNetworkIssueModal();
      return;
    }
    window.scrollTo(0, 0)
    const fqUid = this.props.score.curCard.meta.fq_uid
    this.props.actions.showHint(fqUid)
  }

  onCloseEbook () {
    this.props.actions.closeSplitScreenEbookModal()
    this.setState({
      splitPane: false
    })

    this.props.uiState.isSplitScreenEbookDisplayed = false
    this.props.uiState.isLegacyEbookDisplayed = false
  }

  onToggleEbook () {
    if (this.props.uiState.isSplitScreenEbookDisplayed || this.props.uiState.isLegacyEbookDisplayed) {
      this.onCloseEbook()
    } else {
      if (isVitalSourceURL(this.props.score.curCard.meta.ebook, true).url !== undefined) {
        this.props.uiState.isSplitScreenEbookDisplayed = true
        this.setState({
          splitPane: true
        })
      }
      const ebookString = parseEbookUrl(this.props.score.curCard.meta.ebook)
      this.props.actions.showEbook(this.props.score.curCard.meta.fq_uid,
        this.props.score.curCard.meta.ebook, ebookString)
    }
  }

  onShowScoreValueInfo () {
    this.props.actions.showScoreTooltip()
  }

  onShowQuestionValueInfo () {
    this.props.actions.showQuestionTooltip()
  }

  onChallengeQuestionChange (e) {
    this.props.actions.changeChallengeValue(e.target.value)
  }

  onChallengeIssueTypeChange (value) {
    this.props.actions.changeChallengeIssueTypeValue(value)
  }

  onChallengeEmailChange (e) {
    this.props.actions.changeChallengeEmailValue(e.target.value)
  }

  onCancelChallengeQuestionModal () {
    this.props.actions.closeChallengeQuestionModal()
  }

  onCancelChallengeSentModal () {
    this.props.actions.closeChallengeSentModal()
  }

  onSendChallenge () {
    this.props.uiState.challengeStep === CHALLENGE_EMAIL_STEP
      ? this.props.actions.sendChallengeValue()
      : this.props.actions.nextChallengeStep()
  }

  onMidActivityModalClicked (action) {
    this.props.actions.closeMidActivityModal()
    switch (action) {
      case 'studyPlan':
        this.onPauseActivity()
        break
      case 'nextItem':
        this.onNextItem()
        break
      default:
        this.onNextItem()
        break
    }
  }

  onNextItem () {
    window.scrollTo(0, 0)
    if (this.state.splitPane) {
      this.onCloseEbook()
    }
    this.props.actions.nextItem(this.props.score.curCard.meta.fq_uid)
  }

  onSubmitCoachSignUpModal (phone) {
    this.props.actions.saveCoachSignup(phone)
  }

  onCancelCoachSignUpModal () {
    this.props.actions.closeCoachSignUpModal()
  }

  onPauseActivity () {
    this.props.actions.pauseActivity()
    if (this.props.fromLcrp) {
      this.props.onHideQuiz()
    }
  }

  onResizeSplit (newWidth) {
    this.setState({
      splitLeftFooterWidth: newWidth
    })
  }

  renderQuestion () {
    const curCard = this.props.score.curCard
    return (
      <Question
        onAnswer={curCard.questionType === 'SC' ? this.onSubmitAnswer.bind(this) : this.onAnswer.bind(this)}
        onSubmitFitb={() => this.onSubmitAnswer(this.state.answerSelected)} // only used by FitB modules
        curCard={curCard}
        key={this.props.score.questionStartTime} // use a unique key so that <Question/> will re-render
        legacyEbook={this.props.uiState.isLegacyEbookDisplayed}
        splitPane={this.state.splitPane}
        splitPaneWidth={this.state.splitLeftFooterWidth}
      />
    )
  }

  renderFooter () {
    const curCard = this.props.score.curCard
    const footerClass = curCard.completed
      ? baseStyle.activityFooterWithSecondaryButton
      : baseStyle.activityFooter

    return (
      <FooterBar
        className={!this.state.splitPane || curCard.completed ? footerClass : ''}
        splitPane={this.state.splitPane}
        legacyEbook={this.props.uiState.isLegacyEbookDisplayed}
        width={this.state.splitLeftFooterWidth}
      >
        {curCard.completed
          ? this.renderCorrectFooter()
          : this.state.isAnswerSelected ? this.renderIncorrectFooter() : this.renderDefaultFooter()}
      </FooterBar>
    )
  }

  renderCorrectFooter () {
    let nextQuestionButton
    const activityInProgress = (this.props.score.activityScore >= 0 &&
        this.props.score.activityScore < this.props.score.scoreTarget) ||
        ((this.props.score.activityScore < this.props.score.scoreTarget) &&
        (this.props.score.curCard && !this.props.score.curCard.completed))
    if (this.props.fromLcrp && !activityInProgress) {
      nextQuestionButton = ''
    } else {
      nextQuestionButton = (
        <button
          className={classnames('btn-cdl-main', buttonStyle.footerPrimaryButton)}
          onClick={this.onNextItem}
          tabIndex="0"
        >
          Next question
        </button>
      )
    }
    if (this.props.browser.lessThan.medium ||
      (this.state.splitPane && (this.state.splitLeftFooterWidth === '50%')) ||
      (this.state.splitPane && (window.innerWidth - this.state.splitLeftFooterWidth) <= 768)) {
      return (
        <Grid>
          <Row className={baseStyle.footer}>
            <Col xs={12} className={style.footerButton}>
              {nextQuestionButton}
            </Col>
            <Col xs={12} className={style.footerButton}>
              <button
                data-test-id="takeBreakBtn"
                className={classnames('btn-cdl-secondary', buttonStyle.footerPrimaryButton, style.takeBreakButton)}
                onClick={this.onPauseActivity}
                role="button"
              >
                Take a break
              </button>
            </Col>
          </Row>
        </Grid>
      )
    } else {
      if (this.props.fromLcrp && !activityInProgress) {
        nextQuestionButton = ''
      } else {
        nextQuestionButton = (
          <CenterRoundButton
            data-test-id="nextQuestionBtn"
            onClick={this.onNextItem}
          >
            Next<br />question
          </CenterRoundButton>
        )
      }
      return (
        <div>
          {nextQuestionButton}
          <button
            data-test-id="takeBreakBtn"
            className={classnames('btn-cdl-secondary', style.takeBreak)}
            onClick={this.onPauseActivity}
            role="button"
          >
            Take a break
          </button>
        </div>
      )
    }
  }

  renderIncorrectFooter () {
    if (this.props.browser.lessThan.medium ||
      (this.state.splitPane && (this.state.splitLeftFooterWidth === '50%')) ||
      (this.state.splitPane && (window.innerWidth - this.state.splitLeftFooterWidth) <= 768)) {
      return (
        <Grid>
          <Row className={baseStyle.footer}>
            <Col xs={12} className={style.footerButton}>
              <button
                data-test-id="submitAnswerBtn"
                className={classnames('btn-cdl-main', buttonStyle.footerPrimaryButton)}
                onClick={() => this.onSubmitAnswer(this.state.answerSelected)}
                tabIndex="0"
              >
                Submit answer
              </button>
            </Col>
          </Row>
        </Grid>
      )
    } else {
      return (
        <CenterRoundButton
          data-test-id="submitAnswerBtn"
          onClick={() => this.onSubmitAnswer(this.state.answerSelected)}
        >
          Submit<br />answer
        </CenterRoundButton>
      )
    }
  }

  renderDefaultFooter () {
    const handleEbookDisplay = this.onToggleEbook.bind(this)

    return (
      <ActivityFooter
        browser={this.props.browser}
        curCard={this.props.score.curCard}
        showHint={this.onShowHint.bind(this)}
        showEbook={handleEbookDisplay}
        onDisplayAnswer={this.onDisplayAnswer}
        isEbookAvailable={this.props.uiState.isEbookAvailable || this.props.uiState.isSplitScreenEbookAvailable}
        splitPane={this.state.splitPane}
        legacyEbook={this.props.uiState.isLegacyEbookDisplayed}
        footerWidth={this.state.splitLeftFooterWidth}
      />
    )
  }

  renderIncorrectModal () {
    return this.props.uiState.isIncorrectModalDisplayed
      ? (
        <IncorrectModal
          curCard={this.props.score.curCard}
          onHide={this.props.actions.closeIncorrectModal}
          onChallenge={this.props.actions.challengeQuestionModal}
        />
        )
      : null
  }

  renderSuccessModal () {
    return this.props.uiState.isSuccessModalDisplayed
      ? <SuccessModal
        score={this.props.score}
        curCard={this.props.score.curCard}
        onChallenge={this.props.actions.challengeQuestionModal}
      />
      : null
  }

  renderShowAnswerModal () {
    return this.props.score.curCard.completed && this.props.score.curCard.givenUp
      ? <ShowAnswerModal
        curCard={this.props.score.curCard}
        onChallenge={this.props.actions.challengeQuestionModal}
      />
      : null
  }

  renderSlowDownModal () {
    return this.props.uiState.isSlowDownModalDisplayed
      ? <SlowDownModal onClick={this.props.actions.closeSlowDownModal} />
      : null
  }

  renderSlowDeductModal () {
    return this.props.uiState.isSlowDeductModalDisplayed
      ? <SlowDeductModal onClick={this.props.actions.closeSlowDeductModal} />
      : null
  }

  renderMidActivityModal () {
    return this.props.score.curCard.completed && this.props.uiState.isMidActivityModalDisplayed
      ? <MidActivityModal onClick={this.onMidActivityModalClicked.bind(this)} />
      : null
  }

  renderCompletedActivityModal () {
    if (this.props.fromLcrp) {
      return this.props.score.curCard.completed && this.props.uiState.isCompletedActivityModalDisplayed
        ? <LCRPCompletedActivityModal
          onClick={this.props.actions.closeCompletedActivityModal}
          onBacktoStudyClick={this.onPauseActivity}
          coachButtonText={this.props.coach.offerText}
          onClickCoachButton={this.props.actions.showCoachSignupModal}
          activityTopics={this.props.activityTopics}
          isRetake={this.props.finalScore}
        />
        : null
    } else {
      return this.props.score.curCard.completed && this.props.uiState.isCompletedActivityModalDisplayed
        ? <CompletedActivityModal
          onClick={this.props.actions.closeCompletedActivityModal}
          coachButtonText={this.props.coach.offerText}
          onClickCoachButton={this.props.actions.showCoachSignupModal}
        />
        : null
    }
  }

  renderHint () {
    return this.props.score.hint
      ? <QuestionHint onClick={this.props.actions.hideHint} hint={this.props.score.hint} />
      : null
  }

  renderScoreValueInfo () {
    const complete = this.props.score.curCard.completed && this.props.uiState.isCompletedActivityModalDisplayed
    const { isSplitScreenEbookDisplayed } = this.props.uiState
    return this.props.uiState.showScoreValueInfo
      ? (
        <ScoreValueToolTip
          browser={this.props.browser}
          onClick={this.onShowScoreValueInfo}
          score={this.props.score}
          complete={complete}
          isSplitScreenEbookDisplayed={isSplitScreenEbookDisplayed}
          isPreview={this.props.isPreview}
        />
        )
      : null
  }

  renderQuestionValueInfo () {
    const hintOrIncorrect =
      Boolean(this.props.score.curCard.answeredWrong > 0 ||
      this.props.score.curCard.takenContentHint > 0 ||
      this.props.score.curCard.hinted.length)
    return this.props.uiState.showQuestionValueInfo
      ? (
        <QuestionValueToolTip
          browser={this.props.browser}
          onClick={this.onShowQuestionValueInfo}
          hintOrIncorrect={hintOrIncorrect}
          showAnswer={this.props.score.curCard.givenUp}
          isPreview={this.props.isPreview}
        />
        )
      : null
  }

  renderEbookModal () {
    // strip ebook meta data for display to user
    const ebookData = String(this.props.score.curCard.meta.ebook).replace(/\[+.*\]+/, '')

    return this.props.uiState.isEbookModalDisplayed
      ? <EbookModal onClick={this.props.actions.closeEbookModal} data={ebookData} />
      : null
  }

  renderChallengeQuestionModal () {
    return this.props.uiState.isChallengeQuestionModalDisplayed
      ? (
        <ChallengeQuestionModal
          uiState={this.props.uiState}
          onChallengeQuestionChange={this.onChallengeQuestionChange.bind(this)}
          onChallengeIssueTypeChange={this.onChallengeIssueTypeChange.bind(this)}
          onChallengeEmailChange={this.onChallengeEmailChange.bind(this)}
          onSendChallenge={this.onSendChallenge.bind(this)}
          onCancel={this.onCancelChallengeQuestionModal.bind(this)}
        />
        )
      : null
  }

  renderChallengeSentModal () {
    return this.props.uiState.isChallengeSentModalDisplayed
      ? <ChallengeSentModal
        sendSuccess={this.props.uiState.challengeSendSuccessful}
        onClick={this.onCancelChallengeSentModal.bind(this)}
      />
      : null
  }

  renderCoachSignupModal () {
    return this.props.coach.showSignUpModal
      ? <CoachSignupModal
        coach={this.props.coach}
        onSubmit={this.onSubmitCoachSignUpModal.bind(this)}
        onCancel={this.onCancelCoachSignUpModal.bind(this)}
      />
      : null
  }

  renderProgress () {
    const {
      activityScore,
      scoreTarget,
      curCard
    } = this.props.score

    const potentialProgress = Math.min(scoreTarget - activityScore, curCard.pointsAvailable)

    const questionValue = curCard.completed ? curCard.pointsAchieved.toFixed() : curCard.pointsAvailable.toFixed()

    return (
      <div className={style.achieveProgressContainer}>
        <div className={style.achieveProgressLabels}>
          {this.state.activityHasBeenCompleted
            ? <h2 className={classnames(style.hide768, style.score, 'hidden-xs')}>
              <span
                className={style.value}
                data-test-id="activityScoreValueInfo"
              >Activity Completed</span>
            </h2>
            : <h2 className={classnames(style.hide768, style.score, 'hidden-xs')}>
              {!this.props.finalScore ? 'Score' : 'Retake'}:
              <span
                className={style.value}
                data-test-id="activityScoreValueInfo"
              > {`${activityScore}/${scoreTarget}`}</span>
            </h2>
          }
          <h2 className={classnames(style.hide768, style.score, 'hidden-xs')}>
            <span
              className={style.value}
              data-test-id="activityQuestionPoints"
            > {`Question Value: ${questionValue}`}</span>
          </h2>
        </div>
        <div className={style.progressBarContainer}>
          <CustomProgressBar
            ariaLabel={`You have ${activityScore} points.`}
            dataTestId="activityProgressBar"
            className={classnames('progress', style.progressBar, style.outerProgressBar)}
            bsClass={classnames('progress-bar', progressBarStyle.progressValueBase, style.progressBarValue)}
            max={scoreTarget}
            now={scoreTarget}
            onClick={this.onShowScoreValueInfo}
            style={style}
          >
            <CustomProgressBar
              ariaHidden="true"
              className={classnames('progress', style.progressBar)}
              bsClass={classnames('filledProgressBar', progressBarStyle.progressValueBase, style.filledProgressBar)}
              now={activityScore}
              max={scoreTarget}
              style={style}
            />
            { potentialProgress > 0 &&
              <div 
                className={classnames('progress-bar', 'potentialProgress', progressBarStyle.progressValueBase)} 
                style={{ 
                  width: `${(potentialProgress / scoreTarget) * 100}%`,
                  left: `${(activityScore / scoreTarget) * 100}%`,
                  backgroundColor: 'var(--prs-c-info-600)',
                  borderTopRightRadius: '8px',
                  borderBottomRightRadius: '8px',
                }} 
              />
            }
          </CustomProgressBar>
        </div>
      </div>
    )
  }

  renderLearningCurveContainer () {
    let topBarClass = this.props.isPreview ? baseStyle.activityPreviewTopBarSpace : baseStyle.activityTopBarSpace
    const innerContentStyle = this.props.uiState.isLegacyEbookDisplayed ? style.legacyInnerContent : style.innerContent
    let splitContentStyle = ''
    if ((this.state.splitPane && (this.state.splitLeftFooterWidth === '50%')) ||
      (this.state.splitPane && (window.innerWidth - this.state.splitLeftFooterWidth) <= 768)) {
      splitContentStyle = style.splitContent
    }

    topBarClass = this.props.uiState.isSplitScreenEbookDisplayed ? '' : topBarClass
    topBarClass = (this.props.uiState.isSplitScreenEbookDisplayed && this.props.isPreview)
      ? baseStyle.SplitPreviewSpace
      : topBarClass
    const splitMargin = this.state.splitPane ? style.splitMargin : ''

    return (
      <div className={classnames(style.container, topBarClass, splitMargin)}>
        {this.props.uiState.showArgaError ? <ArgaErrorBar isPreview={this.props.isPreview} /> : null}
        <Grid>
          <Row>
            <Col sm={1} />
            <Col className={style.scoreValueContainer}>
              {this.renderScoreValueInfo()}
            </Col>
            <Col className={style.questionValueContainer}>
              {this.renderQuestionValueInfo()}
            </Col>
          </Row>
        </Grid>
        <Grid className={classnames(innerContentStyle, splitContentStyle)}>
          {headerStyle !== 'default' && this.renderProgress()}
          <div className={style.MathJaxWrapper}>
            {this.renderSlowDownModal()}
            {this.renderSlowDeductModal()}
            {this.renderChallengeQuestionModal()}
            {this.renderChallengeSentModal()}
            {this.renderCompletedActivityModal()}
            {this.renderMidActivityModal()}
            {this.renderShowAnswerModal()}
            {this.renderSuccessModal()}
            {this.renderIncorrectModal()}
            {this.renderHint()}
            {this.renderQuestion()}
            {this.renderEbookModal()}
            {this.renderCoachSignupModal()}
          </div>
        </Grid>
        {this.renderFooter()}
      </div>
    )
  }

  renderSplitPane () {
    return (
      <LCSplitPane
        isPreview={this.props.isPreview}
        browser={this.props.browser}
        toggle={this.onToggleEbook.bind(this)}
        ActivityScoreData={this.props.score}
        outerFooterCalc={this.onResizeSplit.bind(this)}
        lastWidth={this.state.splitLeftFooterWidth}
      >
        {this.renderLearningCurveContainer()}
      </LCSplitPane>
    )
  }

  renderTopBar (headerStyle) {
    const {
      activityScore,
      scoreTarget,
      curCard
    } = this.props.score

    const potentialProgress = Math.min(scoreTarget - activityScore, curCard.pointsAvailable)

    const questionValue = curCard.completed ? curCard.pointsAchieved.toFixed() : curCard.pointsAvailable.toFixed()
    const { lessThan } = this.props.browser

    if (headerStyle === 'achieve') {
      return (
        <TopBar
          isPreview={this.props.isPreview}
          headerStyle="achieve"
          achieveAlignRight
        >
          <button
            data-test-id="backToStudyPlanBtn"
            className={classnames('btn-cdl-secondary', style.headerButton)}
            onClick={this.onPauseActivity}
            tabIndex="0"
          >
            Back to Study Plan
          </button>
        </TopBar>
      )
    }
    return (
      <TopBar isPreview={this.props.isPreview}>
        <Grid className={classnames(baseStyle.topBarWrapper, style.activityTopBar)}>
          <Row className={baseStyle.topBarRow}>
            <Col xs={2} sm={lessThan.medium ? 2 : 3}>
              <h1>
                <Clickable
                  data-test-id="backToStudyPlanBtn"
                  className={style.headerClickable}
                  onClick={this.onPauseActivity}
                  aria-label={this.props.fromLcrp ? 'View Study Plan' : 'Back to Study Plan'}
                  tabIndex="0"
                >
                  <object
                    aria-label={this.props.fromLcrp ? 'view study plan' : 'back to study plan'}
                    data={arrowLeftIcon} type="image/svg+xml"
                    className={classnames(baseStyle.svgIcon, style.backIcon)}
                    tabIndex="-1"
                  />
                  <span className={classnames(style.hide768, style.backText, 'hidden-xs')}>
                    {this.props.fromLcrp ? 'View Study Plan' : 'Back to Study Plan'}
                  </span>
                </Clickable>
              </h1>
            </Col>
            <Col sm={lessThan.medium ? 10 : 6} xs={10}>
              {this.state.activityHasBeenCompleted
                ? <h2 className={classnames(style.hide768, style.headerTitle, style.score, 'hidden-xs')}>
                  Activity Completed
                </h2>
                : <Clickable
                  className={style.headerClickable}
                  onClick={this.onShowScoreValueInfo}
                >
                  <h2 className={classnames(style.hide768, style.headerTitle, style.score, 'hidden-xs')}>
                    {!this.props.finalScore ? 'Score' : 'Retake'}:
                    <span
                      className={style.value}
                      data-test-id="activityScoreValueInfo"
                    > {`${activityScore}/${scoreTarget}`}</span>
                  </h2>
                </Clickable>
              }
              <div className={classnames(style.show768, 'd-block d-sm-none')}>
                {this.state.activityHasBeenCompleted
                  ? <h2 className={classnames(style.headerTitleMobile, style.score)}>
                    Activity Completed
                    <span
                      onClick={this.onShowQuestionValueInfo}
                      className={classnames(style.questionMobile, style.show768)}
                    >
                      {questionValue} pts
                    </span>
                  </h2>
                  : <h2 className={classnames(style.headerTitleMobile, style.score)}>
                    {!this.props.finalScore ? 'Score' : 'Retake'}:
                    <span className={style.value}> {`${activityScore}/${scoreTarget}`}</span>
                    <span
                      onClick={this.onShowQuestionValueInfo}
                      className={classnames(style.questionMobile, style.show768)}
                    >
                      {questionValue} pts
                    </span>
                  </h2>
                }
              </div>
              <CustomProgressBar
                ariaLabel={`You have ${activityScore} points.`}
                dataTestId="activityProgressBar"
                className={classnames('progress', style.progressBar, style.outerProgressBar)}
                bsClass={classnames('progress-bar', progressBarStyle.progressValueBase, style.progressBarValue)}
                max={scoreTarget}
                now={scoreTarget}
                onClick={this.onShowScoreValueInfo}
                style={style}
              >
                <CustomProgressBar
                  ariaHidden="true"
                  className={classnames('progress', style.progressBar)}
                  bsClass={classnames('progress-bar', progressBarStyle.progressValueBase, style.progressBarValue)}
                  now={activityScore}
                  max={scoreTarget}
                  style={style}
                />
                { potentialProgress > 0 &&
                  <div 
                    className={'potentialProgress'} 
                    style={{ 
                      width: `${(potentialProgress / scoreTarget) * 100}%`,
                      left: `${(activityScore / scoreTarget) * 100}%`,
                      backgroundColor: 'var(--prs-c-info-600)',
                      borderTopRightRadius: '8px',
                      borderBottomRightRadius: '8px',
                    }}
                  />
                }
              </CustomProgressBar>
            </Col>
            <Col xs={0} sm={lessThan.medium ? 0 : 3} className={classnames(style.hide768, 'hidden-xs')}>
              <Clickable
                className={style.headerClickableRight}
                onClick={this.onShowQuestionValueInfo}
              >
                <div className={style.question} data-test-id="activityQuestionPoints">
                  Question Value: {questionValue} points
                </div>
              </Clickable>
            </Col>
          </Row>
        </Grid>
      </TopBar>
    )
  }

  render () {
    if (this.props.browser.lessThan.medium && this.props.uiState.isSplitScreenEbookDisplayed) {
      window.scrollTo(0, 0)

      return (
        <EbookSplitMobile
          onClick={this.onToggleEbook.bind(this)}
          ActivityScoreData={this.props.score}
          isPreview={this.props.isPreview}
        />
      )
    }

    const {
      curCard
    } = this.props.score

    if (!curCard) {
      return null
    }

    return (
      <div>
        {headerStyle !== 'hidden' && this.renderTopBar(headerStyle)}
        {this.state.splitPane ? this.renderSplitPane() : this.renderLearningCurveContainer()}
      </div>
    )
  }
}

Activity.propTypes = {
  browser: PropTypes.object.isRequired,
  score: PropTypes.object.isRequired,
  uiState: PropTypes.object.isRequired,
  coach: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  activityTitle: PropTypes.string.isRequired,
  activityTopics: PropTypes.array.isRequired,
  isPreview: PropTypes.bool,
  fromLcrp: PropTypes.bool,
  onHideQuiz: PropTypes.func,
  finalScore: PropTypes.object
}
